export default __webpack_public_path__ + "0c1a717.png";